import { BehaviorSubject, Observable, of, Subscription } from 'rxjs';
import { Injectable, OnDestroy } from '@angular/core';
import { User } from './interfaces';
import { shareReplay, switchMap } from 'rxjs/operators';

import {
  Firestore, //constructor
  collection,
  query,
  where,
  orderBy,
  doc,
  collectionData, //subscription
  getDoc, //promise
  setDoc,
  arrayUnion,
  updateDoc,
  getDocs,
  docData,
  addDoc
} from '@angular/fire/firestore';

@Injectable({
  providedIn: 'root'
})
export class ScopeService implements OnDestroy {

  public scopedUser$: Observable<User | null>;
  public scopedUserId$ = new BehaviorSubject<string>(null);
  // public selectedUserName = new BehaviorSubject<string>('');

  private activeUser: User;

  private scopedUserSub: Subscription;
  constructor(
    private afs: Firestore,
  ) {
    this.scopedUser$ = this.scopedUserId$
     .pipe(switchMap(id => {
      if (id) {
        // return this.afs.collection('Users').doc<User>(id).valueChanges({idField: 'id'})
        return docData(doc(this.afs, `Users/${id}`), { idField: 'id' });
      } else {
        return of(null)
      }
     }), shareReplay(1));
  }

  public viewAsActiveUser() {
    this.scopedUserId$.next(this.activeUser.id);
  }

  // set from first signin
  public setActiveUser(user: User) {
    this.activeUser = user;
  }

  ngOnDestroy() {


  }
}
